<template>
  <v-text-field
    v-model="query"
    hide-details
    full-width
    filled
    clearable
    :loading="loading"
    append-icon="mdi-magnify"
    :label="$t(`Rechercher · utilisateur`)"
    class="users-forms-search-field"
  />
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { mapUserSearchFormFields } from "@/store/modules/user";
import { SEARCH } from "@/store/action-types";

const { mapActions: mapUserSearchFormActions } = createNamespacedHelpers(
  `user/searchForm`
);

export default {
  data() {
    return {
      loading: false
    };
  },
  // Here we're wiring everything up.
  computed: {
    // You can read more about mapping field
    // values in two of my previous articles.
    // https://markus.oberlehner.net/blog/form-fields-two-way-data-binding-and-vuex/
    // https://markus.oberlehner.net/blog/how-to-handle-multi-row-forms-with-vue-vuex-and-vuex-map-fields/
    ...mapUserSearchFormFields(["query"])
  },
  methods: {
    ...mapUserSearchFormActions({
      search: SEARCH
    })
  },
  watch: {
    async query(query) {
      this.$gtm.trackEvent({
        event: "interaction",
        category: "user",
        action: "search",
        label: query
      });
      this.loading = true;
      await this.search();
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
.users-forms-search-field {
  min-width: 320px;
}
</style>
